import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';

import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFirestoreModule } from 'angularfire2/firestore';

import { MillManagerPage } from '../pages/mill-manager/mill-manager';
import { DeliveryPage } from '../pages/delivery/delivery';
import { DeliveryAddPage } from '../pages/delivery-add/delivery-add';
import { PickupPage } from '../pages/pickup/pickup';
import { PickupAddPage } from '../pages/pickup-add/pickup-add';
import { ProductionPage } from '../pages/production/production';
import { ProductionAddPage } from '../pages/production-add/production-add';
import { ContactsPage } from '../pages/contacts/contacts';
import { ContactsAddPage } from '../pages/contacts-add/contacts-add';
import { HelpPage } from '../pages/help/help';
import { LoginPage } from '../pages/login/login';
import { SmpPage } from '../pages/smp/smp';
import { SmpAddPage } from '../pages/smp-add/smp-add';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AuthProvider } from '../providers/auth/auth';
import { DatabaseProvider } from '../providers/database/database';
import { UIProvider } from '../providers/ui/ui';


import { Camera } from '@ionic-native/camera';
import { CallNumber } from '@ionic-native/call-number';

var firebaseConfig = {
  apiKey: "AIzaSyDSPDZtWzCMdMIiba7MQ6BXbHHlWrNcL38",
  authDomain: "mill-manager.firebaseapp.com",
  databaseURL: "https://mill-manager.firebaseio.com",
  projectId: "mill-manager",
  storageBucket: "mill-manager.appspot.com",
  messagingSenderId: "933784835697"
};
//firebase.initializeApp(firebaseConfig);

@NgModule({
  declarations: [
    MyApp,
    MillManagerPage,
    DeliveryPage,
    DeliveryAddPage,
    PickupPage,
    PickupAddPage,
    ProductionPage,
    ProductionAddPage,
    ContactsPage,
    ContactsAddPage,
    HelpPage,
    LoginPage,
    SmpPage,
    SmpAddPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFirestoreModule.enablePersistence(),
    AngularFireAuthModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    MillManagerPage,
    DeliveryPage,
    DeliveryAddPage,
    PickupPage,
    PickupAddPage,
    ProductionPage,
    ProductionAddPage,
    ContactsPage,
    ContactsAddPage,
    HelpPage,
    LoginPage,
    SmpPage,
    SmpAddPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    AuthProvider,
    DatabaseProvider,
    UIProvider,
    Camera,
    CallNumber
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts